import { useMonitor } from '../use-monitor';

export function useMonitorAddIssueTemplatesFormIssueSubtypesLoad() {
  return useMonitor('add-issue-templates-form-issue-subtypes-load');
}
